import React, { Component, Fragment } from 'react';
import intl from 'react-intl-universal';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';


class NewPasswordUserMe extends Component {

  constructor(props) {
    super(props);

    this.state = {
      password: "",
      password1: "",
      passworderror: false
    }
}

handleChange(e) {
  this.setState({
    [e.target.name]: e.target.value
  })
}

submitsetpassworduser = (event) =>{  
  event.preventDefault()

  if (this.state.password !== this.state.password1) {
    this.setState ({
        passworderror: true
    })
  } else {
  let jsonfields= "";
  jsonfields += '"password": "' + event.currentTarget.password.value + '"';
  
  let json = "";
  json = '{';
  json += jsonfields;
  json += '}';

  console.log(json)
   this.setpassworduser(this.props.token,json)
}
}

 setpassworduser (token,json)  {
  let apiurl = window.apiurl
  console.log(json)
  fetch("https://"+apiurl+"/api/User/me/setPassword", {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
      body: json
    })
      .then(res => res.json())
      .then(json => {
        console.log("---------------")
        console.log(json)
        console.log("---------------")
        this.props.closedit()
      })
      .catch(function(error) {
          console.log(error.status);
        });         
    }

    render () {  
        
       console.log (this.state)
      
      
        
      return (
          <Fragment>
          <Container maxWidth="sm">
          <CloseIcon onClick={()=>this.props.closedit()} />

          <Typography variant="h6" gutterBottom>
          {intl.get('ACCOUNT_EDIT_PW')}:
 </Typography>

 {this.state.passworderror &&
        <Alert severity="error">{intl.get('ACCOUNT_EDIT_PW_ALERT')}</Alert>
    }

   

<Box component="form" onSubmit={this.submitsetpassworduser}  Validate >
 <Grid container spacing={3}>
   <Grid item xs={12}>
     <TextField
       required
       id="password"
       name="password"
       label={intl.get('ACCOUNT_EDIT_FORM_PW')}
       value={this.state.password}   
       onChange={(e) => this.handleChange(e)}
       fullWidth
       type="password"
       variant="standard"
     />
   </Grid>
   <Grid item xs={12}>
     <TextField 
       required
       id="password1"
       name="password1"
       label={intl.get('ACCOUNT_EDIT_FORM_PW1')}
       value={this.state.lastName} 
       onChange={(e) => this.handleChange(e)}
       fullWidth
       type="password"
       variant="standard"
     />
   </Grid>
   
       <Grid item xs={12}>
       <Button
       type="submit"
       fullWidth
       variant="contained"
       sx={{ mt: 3, mb: 2 }}
     >
       {intl.get('ACCOUNT_EDIT_FORM_SUBMIT_PW')} :
     </Button>
     </Grid>

 </Grid>
 </Box>
 
 </Container>
 </Fragment> 
        )
    }
}


export default NewPasswordUserMe;